import auth from './auth';
import firebase from './firebase';

const boots = [firebase, auth];

export default function bootstrap(context) {
  boots.forEach((boot) => boot(context));
}
